import React from 'react';
import { motion } from 'framer-motion';
import type { Cluster } from '../types/teaser';
interface ClusterImageProps {
  cluster: Cluster;
  /** Zoom into the central retina for small features. */
  zoom?: boolean;
  /** Aspect ratio class for the visible crop. */
  className?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function ClusterImage({
  cluster,
  zoom = false,
  className = ''
}: ClusterImageProps) {
  return <div className={`relative overflow-hidden bg-[#0A0F14] ${className}`} data-id="element-60" data-mp="hxrtx8iuenjf">
      <motion.img src={cluster.image} alt={`AI-assisted OCT segmentation example — ${cluster.name}, ${cluster.descriptor}`} draggable={false} animate={{
      scale: zoom ? 2.1 : 1,
      y: zoom ? '6%' : '0%'
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="block h-full w-full select-none object-cover object-top" data-id="element-61" data-mp="mqb9uc505ure" />
    </div>;
}